const resource = {
  "main": {
    "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI가 목표와 레벨에 맞춰 루틴을 설계하고 기록까지 챙깁니다."])},
    "tagline": {
      "line1": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["모든 운동과 식사를 위한 당신의 "])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 코치."])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line2": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line3": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["루틴을 만들고 운동을 기록하며,\n다음 훈련을 확인하세요.\n식사를 입력하고 식단을 관리하면,\nAI가 영양 균형까지 평가합니다."])}
    },
    "previewImageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동·식단·AI 코칭 기능을 보여주는 앱 메인 화면"])},
    "signalLabels": {
      "aiPersonalizedRoutines": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 맞춤 루틴"])},
      "nextWorkoutGuidance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["다음 운동 가이드"])},
      "aiMealEvaluation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 식사 평가"])}
    }
  },
  "home": {
    "valueProps": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["왜 AI 운동 코치인가요?"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["하나의 기록이 더 나은 다음 운동으로"])},
      "items": {
        "routine": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 맞춤 루틴"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["목표와 운동 수준에 맞춰 실행하기 좋은 루틴을 구성합니다."])}
        },
        "insights": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["기록 기반 분석"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동·식단·체중 기록을 연결해 변화의 흐름을 보여줍니다."])}
        },
        "next": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["다음 행동 제안"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["내 기록을 바탕으로 다음 운동에서 조정할 부분을 알려줍니다."])}
        }
      }
    },
    "mealManagement": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["식단 관리"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오늘의 영양 상태를\n한눈에 확인하세요"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["끼니별 칼로리와 탄단지를 한곳에서 관리하세요.\n\n- 하루 목표와 실제 섭취량 비교\n- 탄수화물·단백질·지방 균형 확인\n- 기록을 마친 끼니를 한눈에 표시"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["식단 관리 앱 화면"])}
    },
    "mealInput": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 식사 분석"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["식사를 기록하면\nAI가 바로 분석합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["사진이나 텍스트를 추가하면 영양 정보를 보기 쉽게 정리합니다.\n\n- 몇 초 만에 식사 기록\n- 칼로리와 탄단지 자동 계산\n- 끼니별 AI 평가 확인"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["사진과 텍스트로 식사를 입력하고 AI 평가 결과를 확인하는 앱 화면"])}
    },
    "about": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["스마트 루틴"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["내 운동 루틴을\n템플릿으로 관리하세요"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["훈련 방식에 맞는 템플릿을 만들고 반복해서 사용하세요.\n\n- 부위별 운동 구성\n- 자주 쓰는 루틴을 바로 실행\n- 매번 다시 설정하지 않고 운동 시작"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["루틴 인사이트 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 루틴 템플릿을 보여주는 앱 화면"])}
    },
    "nutrition": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["변화 인사이트"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["몸과 운동의 변화를\n한눈에 확인하세요"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["체성분과 운동 지속 현황을 하나의 화면에서 확인하세요.\n\n- 체중·근육량·체지방 변화 추적\n- 최근 운동 활동 확인\n- 점검이 필요한 변화 파악"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성장 인사이트 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["체성분 변화와 최근 운동 활동을 보여주는 앱 화면"])}
    },
    "weight": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 리뷰"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동이 끝나면\nAI가 바로 리뷰합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI가 이번 운동을 최근 훈련 기록과 비교합니다.\n\n- 세트·횟수·중량·볼륨 확인\n- 잘한 점 정리\n- 다음 운동의 조정 포인트 제안"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 리뷰 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["완료한 운동의 AI 평가를 보여주는 앱 화면"])},
      "reviewCard": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오늘의 AI 리뷰"])},
        "metric": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+8%"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 볼륨이 증가했어요"])},
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["다음 운동에서는 현재 중량을 유지하고 반복 횟수를 1회 늘려보세요."])}
      }
    },
    "aboutPro": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["장기 분석"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 기록을\n하나의 흐름으로 요약합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI가 여러 운동을 연결해 전체적인 훈련 방향을 보여줍니다.\n\n- 운동별 볼륨 비교\n- 장기적인 변화 확인\n- 성장한 점과 부족한 부분 파악"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성장 인사이트 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 기록의 AI 요약을 보여주는 앱 화면"])}
    },
    "formulas": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI가 모든 운동을 평가합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["기록된 모든 운동을 AI가 분석해\n현재 상태와 개선 포인트를 알려줍니다\n\n- 운동 종류 자동 인식\n- 반복·중량·볼륨 분석\n- 최근 기록 기준 피드백\n\n운동을 하나씩이 아닌, 흐름으로 봅니다"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["내 기록 피드백 보기"])}
    },
    "weightManagement": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["체중 관리"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["체중을 기록하고\n변화의 흐름을 확인하세요"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동 기록과 함께 체중 변화를 비교하고, 진행 상황에 맞는 AI 점검을 받아보세요."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["체중 변화 그래프와 AI 점검을 보여주는 체중 관리 앱 화면"])}
    },
    "downloadCta": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["내 기록으로 더 똑똑하게 운동하세요"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["운동·식단·체중 기록을 한곳에서 관리하고, 내가 기록한 데이터를 바탕으로 AI 피드백을 받아보세요."])}
    }
  },
  "navigation": {
    "navbar": {
      "appTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 운동 코치"])},
      "languages": {
        "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["영어"])},
        "de": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["독일어"])},
        "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["스페인어"])},
        "fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["프랑스어"])},
        "pt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["포르투갈어"])},
        "zh-TW": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["중국어 번체"])},
        "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이탈리아어"])},
        "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인도네시아어"])},
        "th": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["태국어"])},
        "ar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["아랍어"])},
        "kr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한국어"])},
        "jp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["일본어"])}
      },
      "subpages": {
        "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["더 알아보기"])},
        "appStore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["앱 스토어"])},
        "googlePlay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["구글 플레이"])},
        "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulas"])},
        "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Books"])},
        "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Articles"])},
        "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statistics"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations"])},
        "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Donate"])}
      }
    },
    "footer": {
      "copyrights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All photos and logos used are copyright-free and made available under the MIT or CC license. It is allowed to use, copy, modify or distribute the original or modified content on this website without restriction, provided that the authorship is acknowledged and the source information is posted."])}
    }
  },
  "sciences": {
    "groups": {
      "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
      "natural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Natural"])},
      "social": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Social"])},
      "humanities": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Humanities"])},
      "technical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technical"])},
      "artistic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artistic"])},
      "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Others"])}
    },
    "sciences": {
      "philology_iberian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iberian Philology"])},
      "philology_english": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English Philology"])},
      "philology_france": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["French and Benelux Philology"])},
      "philology_italian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italian Philology"])},
      "philology_german": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["German Philology"])},
      "philology_poland": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polish, Ukrainian and Lithuanian Philology"])},
      "philology_baltic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baltic Philology"])},
      "philology_nordic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nordic Philology"])},
      "philology_russian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Russian Philology"])},
      "philology_carpathian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carpathian Philology"])},
      "philology_romanian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Romanian nad Bulgarian Philology"])},
      "philology_balkan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["West-Balkan Philology"])},
      "philology_greek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greek Philology"])},
      "philology_turkish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turkish Philology"])},
      "philology_middleeast": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Middle East, Arabic and Persian Philology"])},
      "philology_indian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indian Philology"])},
      "philology_chinese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chinese Philology"])},
      "philology_korean": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korean Philology"])},
      "philology_japanese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Japanese Philology"])},
      "anthropology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anthropology"])},
      "philosophy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Philosophy"])},
      "history": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History"])},
      "historyofart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History of Art"])},
      "culturalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultural Studies"])},
      "politology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politology"])},
      "law": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Law"])},
      "psychology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Psychology"])},
      "theology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Theology"])},
      "defensestudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Defense Studies"])},
      "sociology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociology"])},
      "internationalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["International Studies"])},
      "economics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Economics"])},
      "finances": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finances"])},
      "accountancy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accountancy"])},
      "econometrics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Econometrics"])},
      "governance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Governance"])},
      "management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Management"])},
      "astronomy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Astronomy"])},
      "bioinformatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bioinformatics"])},
      "biochemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biochemistry"])},
      "biophysics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biophysics"])},
      "biotechnology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biotechnology"])},
      "biology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biology"])},
      "chemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chemistry"])},
      "physics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Physics"])},
      "geography": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geography"])},
      "geology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geology"])},
      "informatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informatics"])},
      "math": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mathematics"])},
      "ecology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ecology"])},
      "architecture": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Architecture"])},
      "robotics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Robotics"])},
      "building_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Building Engeenering"])},
      "energetics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energetics"])},
      "electronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Electronics"])},
      "quantum_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantum Engeenering"])},
      "cosmonautics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosmonautics"])},
      "mechanics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechanics"])},
      "mechatronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechatronics"])},
      "transport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transport"])}
    },
    "branches": {
      "physics": {
        "kinematics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinematics"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We study the motion of bodies, including their acceleration, path and speed"])},
          "subjects": {
            "linear-motion": {
              "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linear Motion"])},
              "formulas": {
                "velocity-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average speed"])},
                "velocity-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous speed"])},
                "acceleration-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average acceleration"])},
                "acceleration-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous acceleration"])},
                "motion-eq-a": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 1"])},
                "motion-eq-b": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 2"])},
                "motion-eq-c": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 3"])},
                "motion-eq-d": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 4"])}
              }
            }
          }
        },
        "dynamics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dynamika"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zajmiemy się opisem sił działających na różne ciała, a także ich skutkami"])}
        },
        "energy": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energia"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praca moc i energia to wielkości, które pozwolą nam spojrzeć na mechanikę z innej strony, a także będą wstępem do kolejnych działów fizyki."])}
        }
      },
      "electronics": {
        "current": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prąd elektryczny"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaczynamy od podstaw, czyli czym jest prąd elektryczny"])}
        }
      }
    },
    "units": {
      "velocity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prędkość"])},
      "distance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Droga"])},
      "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czas"])},
      "acceleration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przyspieszenie"])}
    }
  },
  "pages": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strona główna"])},
    "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tablice"])},
    "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artykuły"])},
    "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podręczniki"])},
    "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statystyki"])},
    "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje"])},
    "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
  },
  "formulas": {
    "index": {
      "hero": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wzory i tablice naukowe"])}
    },
    "pick": {
      "science": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz jedną z kategorii"])},
      "branch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz dziedzinę nauki, która cię interesuje"])}
    }
  },
  "errors": {
    "404": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nasz system nie znalazł takiej strony :c"])},
      "duck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Więc łap chociaż na pocieszenie kaczkę"])},
      "yeah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak, to ten sławny bląd 404"])},
      "song": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bit, bit i pusta kartka, drukarka wydaje szmery Nie ma mnie, bo to nocnego marka nocna warta Świeci się tarcza zegarka - 4:04 Nic nie psuje atmosfery, dźwięki smarta czy wiertarka"])}
    }
  },
  "info": {
    "sure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ale czy aby na pewno?"])},
    "sections": {
      "begginings": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Początki"])}
      },
      "activity": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działalność"])}
      },
      "goalsandplans": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cel i plany"])}
      },
      "software": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oprogramowanie"])},
        "langscategories": {
          "front-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Front-End"])},
          "back-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back-End"])},
          "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilne"])},
          "databases": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bazy danych"])},
          "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inne"])}
        }
      },
      "sponsors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sponsorzy"])}
      },
      "authors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorzy"])}
      },
      "thanks": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podziękowania"])}
      },
      "donate": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
      },
      "join": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dołącz"])}
      },
      "contact": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakt"])}
      }
    }
  }
}
export default resource